import { BtnPageTopOld } from '@wconcept/wconcept-ui-renewal/components/atoms/svg';
import { classNameBind } from '@wconcept/wconcept-common/utils/commonUtils';

import * as S from './style';

interface IProps {
  className?: string;
  onClick?: () => void;
}

const TopBtnOld = ({ className, onClick }: IProps) => {
  const cName = classNameBind(['top-btn TopBtnOld', className || '']);

  return (
    <S.TopBtnOld
      className={cName}
      onClick={onClick}
      label="페이지 맨위로 이동"
      icon={<BtnPageTopOld />}
    />
  );
};

export default TopBtnOld;
